<template>
    <Dialog v-model="showModal" class="sm:max-w-[420px]">
        <DialogHeader>
            <DialogTitle>{{ $t('views.monitoring.groupOverview.modals.createGroup.title') }}</DialogTitle>
            <VisuallyHidden>
                <DialogDescription class="pt-4">{{ $t('views.monitoring.groupOverview.modals.createGroup.description') }}</DialogDescription>
            </VisuallyHidden>
        </DialogHeader>
        <form class="mt-4" @submit.prevent="handleContinue">
            <CustomSelect
                v-model:value="sectionId"
                :items="sectionOptions"
                :rules="[{ validate: (value: any) => value !== null, message: '' }]"
                item-text="name"
                item-value="id"
                :label="$t('views.monitoring.groupOverview.modals.createGroup.fields.section')"
                required
                :allow-empty="false"
            />
        </form>
        <DialogFooter class="mt-4">
            <DialogClose as-child>
                <CustomButton color-preset="white">{{ $t('views.monitoring.groupOverview.modals.createGroup.buttons.cancel') }}</CustomButton>
            </DialogClose>
            <CustomButton :disabled="sectionId === null" @click="handleContinue">{{ $t('views.monitoring.groupOverview.modals.createGroup.buttons.continue') }}</CustomButton>
        </DialogFooter>
    </Dialog>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { VisuallyHidden } from 'radix-vue';
import CustomButton from '@/components/ui/CustomButton.vue';
import { Dialog, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogClose } from '@/components/ui/dialog';
import CustomSelect from '@/components/ui/CustomSelect.vue';
import { store } from '@/plugins/store';
import { Barn } from '@/types';

// First step of Groups overview's create flow: which Section of this Barn to start a Production
// Group on. The rich fields (name, dates, pig-tally context) live in the shared
// ManageProductionGroupModal - this step exists only because Groups overview's "Create group"
// button is scoped to a Barn rather than to one Section already, unlike Active groups.
const props = defineProps<{
    barn: Barn;
}>();
const emit = defineEmits<{
    chosen: [sectionId: number];
}>();

const showModal = defineModel<boolean>('modelValue');

const sectionId = ref<number | null>(null);
const sectionOptions = computed(() => store.state.sections?.filter((s) => s.barn_id === props.barn.barn_id) ?? []);

function handleContinue() {
    if (sectionId.value === null) {
        return;
    }

    emit('chosen', sectionId.value);
    showModal.value = false;
}

watch(showModal, (value) => {
    if (!value) {
        setTimeout(() => {
            sectionId.value = null;
        }, 300);
    }
});
</script>
